import React, { Component } from 'react'
import { getCampusLocations, getTileTypes } from '../../services/reservoir'
import { connect } from 'react-redux'
import AdmissionCategory from '../../enums/AdmissionCategory'
import {
  receiveSelectedCategory,
  receiveSelectedLocation
} from '../../actions/tiles'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'

const mapStateToProps = ({
  courses: { selectedCourseCode, data },
  course: { selectedCourse },
  tiles: {
    selectedCategory,
    selectedLocation: { locationName }
  }
}) => {
  return {
    forcedLocation: selectedCourse.frcdLoc === 'Y',
    admissionCategory: selectedCourse.admissionCategory,
    locationName: locationName,
    categoryName: selectedCategory
  }
}

const mapDispatchToProps = dispatch => {
  return {
    switchTilesLocation: locationName => {
      dispatch(receiveSelectedLocation(locationName))
    },
    switchTilesCategory: categoryName => {
      dispatch(receiveSelectedCategory(categoryName))
    }
  }
}

class Filter extends Component {
  constructor(props) {
    super(props)

    this.state = {
      categories: [],
      locations: []
    }
  }

  componentDidMount() {
    getTileTypes()
      .then(tileTypes => {
        return tileTypes.map(tileType => {
          return {
            name: tileType.attributes.name,
            plural: tileType.attributes.field_plurals
          }
        })
      })
      .then(tileTypes => {
        this.setState({
          categories: tileTypes
        })
      })

    getCampusLocations()
      .then(campusLocations =>
        campusLocations.map(location => location.attributes.name)
      )
      .then(campusLocations => {
        this.setState({
          locations: campusLocations
        })
      })
  }

  updateCategoryFilter = event => {
    event.preventDefault()

    this.props.switchTilesCategory(event.target.value)
  }

  updateLocationFilter = event => {
    event.preventDefault()

    this.props.switchTilesLocation(event.target.value)
  }

  renderCategoryFilter = () => {
    return (
      <span>
        Show me{' '}
        <label className="sr-only" htmlFor="categoryFilter">
          Category
        </label>
        {this.renderCategorySelect()}
      </span>
    )
  }

  renderCategorySelect = () => (
    <FormControl variant='standard'>
      <Select
        id="categoryFilter"
        className='select'
        value={this.props.categoryName || ""}
        displayEmpty
        onChange={this.updateCategoryFilter}
      >
        <MenuItem value="">Everything</MenuItem>
        {this.state.categories.map((category, index) => (
          <MenuItem key={index} value={category.name}> {category.plural} </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
  

  renderLocationFilter = () => {
    if (this.props.forcedLocation) {
      return null
    }

    switch (this.props.admissionCategory) {
      case AdmissionCategory.HigherEdOffshore:
      case AdmissionCategory.TAFEOffshore:
      case 'OFFSHORE':
        return null
      default:
        return (
          <span>
            {' '}
            at{' '}
            <label className="sr-only" htmlFor="locationFilter">
              Location
            </label>
            {this.renderLocationSelect()}
          </span>
        )
    }
  }

  renderLocationSelect = () => {
    return this.state.locations.length ? (
      <FormControl variant='standard'>
        <Select
          id="locationFilter"
          className='select'
          value={this.props.locationName}
          onChange={this.updateLocationFilter}
        >
          <MenuItem value="">All Campuses</MenuItem>
          {this.state.locations.map((location, index) => (
            <MenuItem key={index} value={location}>{location}</MenuItem>
          ))}
        </Select>
      </FormControl>
    ) : null
  }

  render() {
    return (
      <div className="filter-container">
        {this.renderCategoryFilter()}
        {this.renderLocationFilter()}
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Filter)
